import React from 'react';
import PropTypes from 'prop-types';
import ReduxDrawer from 'containers/DrawerManager/ReduxDrawer';
import { AUTOPAY_SIGN_UP } from '../constants';
import AutopaySignUpForm from './form';

const AutopaySignUpDrawer = ({
  drawerProps = {},
  formProps = {},
  drawerKey = AUTOPAY_SIGN_UP,
}) => (
  <ReduxDrawer
    WrappedComponent={AutopaySignUpForm}
    drawerKey={drawerKey}
    drawerProps={{
      headerTitle: 'AutoPay sign-up',
      ...drawerProps,
    }}
    props={formProps}
  />
);

AutopaySignUpDrawer.propTypes = {
  drawerProps: PropTypes.object,
  formProps: PropTypes.object,
  drawerKey: PropTypes.string,
};

export default AutopaySignUpDrawer;
